module.exports = __webpack_public_path__ + "static/media/roboto-v20-latin-regular.60fa3c06.woff";